import { Collection } from '.';
import { SampleCollectionLocation } from './samples.types';

export enum AwaitingSampleSerieStatus {
  AWAITING = 'AWAITING',
  VALID = 'VALID',
}
export interface AwaitingSamples {
  total: number;
  AT_HOME: Collection;
  IN_PERSON: Collection;
}

export interface AwaitingSamplesResponse {
  collectionLocation: SampleCollectionLocation;
  value: number;
}
